import React, { useEffect } from 'react'
import Breadcrumb from 'components/Breadcrumb'
import { Page, pages } from 'pages/pages'
import {
  ProfileButton,
  ProfileContainer,
  ProfileHeaderContainer,
  ProfileInfo,
  ProfileInfoContainer,
  ProfileTitle,
  ProfileTitleContainer,
} from './Profile.styled'

import ProfileFormTemplate from 'templates/ProfileFormTemplate'
import Table from 'components/Table'
import FacilityItem from 'components/FacilityItem'
import { useAppDispatch, useAppState } from 'store'
import { userActions } from 'store/slices/users/users.slice'
import moment from 'moment'

const FACILITY_LIST_HEADER: string[] = ['Facility Name', 'Last Appointment']

const ProfilePage: React.FC = () => {
  const PROFILE_BREADCRUMB: Page[] = [pages.Home, pages.Profile]
  const dispatch = useAppDispatch()
  const { userProfile, userAppointments } = useAppState(state => state.user)
  const { user } = useAppState(state => state.auth)

  useEffect(() => {
    if (user && !userProfile) {
      dispatch(userActions.getUserProfile(user.id))
    }
  }, [user, userProfile])

  useEffect(() => {
    if (userAppointments && !userAppointments.length && user) {
      dispatch(userActions.getUserAppointments(user.id))
    }
  }, [user, userAppointments])

  return (
    <ProfileFormTemplate>
      <ProfileContainer>
        <Breadcrumb breadcrumbPages={PROFILE_BREADCRUMB} />

        <ProfileHeaderContainer>
          {user && (
            <ProfileInfoContainer>
              <ProfileTitleContainer>
                <ProfileTitle>
                  {user.name} {user.last_name}
                </ProfileTitle>
                <ProfileButton type={'primary'} style={{ marginLeft: 30 }}>
                  view profile
                </ProfileButton>
                <ProfileButton type={'secondary'} style={{ marginLeft: 30 }}>
                  logout
                </ProfileButton>
              </ProfileTitleContainer>
              <ProfileInfo>{user.email}</ProfileInfo>
              <ProfileInfo style={{ marginTop: 10 }}>
                Member Since {moment(user.created_at).format('MM/YYYY')}
              </ProfileInfo>
            </ProfileInfoContainer>
          )}
        </ProfileHeaderContainer>
        <div style={{ marginTop: 40 }}>
          <Table header={FACILITY_LIST_HEADER}>
            {userAppointments &&
              userAppointments.length > 0 &&
              userAppointments.map(appointment => (
                <FacilityItem key={appointment.id} appointment={appointment} />
              ))}
          </Table>
        </div>
      </ProfileContainer>
    </ProfileFormTemplate>
  )
}

export default ProfilePage
